import React,{useRef,useState,useEffect,Fragment}from'react';import classnames from'classnames';import {Input}from'antd';import {ContextMenuModal}from'tncet-common';import {DYMODE_MODE}from'pytha';function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1 = ".y-button {\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n  white-space: nowrap;\n  text-align: center;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px #00000004;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  height: 32px;\n  padding: 4px 15px;\n  font-size: 14px;\n  border-radius: 2px;\n  color: #000000d9;\n  border-color: #d9d9d9;\n  background: #fff;\n}\n.y-button-primary {\n  color: #fff;\n  border-color: #1890ff;\n  background: #1890ff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px #0000000b;\n}\n";
styleInject(css_248z$1);const prefix = 'y';
var index = (props) => {
    const cName = `${prefix}-button`;
    return (React.createElement("button", { className: classnames(cName, cName + '-' + (props.type || "default")) }, props.children));
};var css_248z = ".dymode-input-container {\n  display: flex;\n  align-items: center;\n}\n.dymode-input-container .dymode-tip {\n  background-color: #999999;\n  border: 1px solid #000;\n  padding: 2px 10px;\n  min-width: 100px;\n  flex-shrink: 0;\n  margin-right: 4px;\n  font-size: 13px;\n  height: 26px;\n}\n.dymode-input-container .dymode-input {\n  border-radius: 0;\n  width: 70px;\n  font-size: 12px;\n  outline: 0px;\n  margin-right: 4px;\n}\n.dymode-input-container .dymode-input.disabled {\n  background-color: #999999;\n  border: 1px solid #000;\n}\n.dymode-input-container .dymode-input.hidden {\n  display: none;\n}\n.dymode-input-container .dymode-input.danger {\n  border: 2px solid #ff0000;\n}\n.dymode-input-container .dymode-angle-tip {\n  background-color: #999999;\n  border: 1px solid #000;\n  padding: 0px 10px;\n  flex-shrink: 0;\n  margin-right: 4px;\n  font-size: 13px;\n  height: 20px;\n}\n.dymode-input-container .command-list {\n  margin-top: 2px;\n  max-height: 100px;\n  border: 1px solid #000;\n  overflow: auto;\n  background-color: #fff;\n  min-width: 150px;\n  display: none;\n}\n.dymode-input-container .command-list.visible {\n  display: block;\n}\n.dymode-input-container .command-list .cmd-item {\n  padding: 0 4px;\n  user-select: none;\n  cursor: pointer;\n}\n.dymode-input-container .command-list .cmd-item.active {\n  background-color: #0168B3;\n  color: #fff;\n}\n.dymode-input-container .command-list .cmd-item:hover:not(.active) {\n  background-color: #eaeaea;\n}\n.dymode-input-container .command-input {\n  ime-mode: disabled;\n}\n";
styleInject(css_248z);const NumFixed = (value, n) => {
    return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
};function DymodeInput(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const refX = useRef();
    const refY = useRef();
    const refZ = useRef();
    const refChoose = useRef();
    const refAngle = useRef();
    const refDist = useRef();
    const refNumber = useRef();
    const refCommand = useRef();
    const [inputVisible, setInputVisible] = useState(false);
    const [left, setLeft] = useState(0);
    const [top, setTop] = useState(0);
    const [mask, setMask] = useState(false);
    const [x, setX] = useState(null);
    const [y, setY] = useState(null);
    const [z, setZ] = useState(null);
    const [angle, setAngle] = useState(null);
    const [dist, setDist] = useState(null);
    const [focus, setFocus] = useState('x');
    const [choose, setChoose] = useState(null);
    const [number, setNumber] = useState(null);
    const [command, setCommand] = useState(null);
    const [zVisible, setZVisible] = useState(false);
    const [cmdString, setCmdString] = useState(null);
    const [displayCmdList, setDisplayCmdList] = useState([]);
    const [updatePage, setUpdatePage] = useState(0);
    useEffect(() => {
        if (props.extraContext && props.extraContext.getCurrentViewEditor()) {
            const editor = props.extraContext.getCurrentViewEditor();
            editor.listeners.signals.onDymodeVisible.add(onDymodeVisibleChange);
            editor.listeners.signals.onProcessEscape.add(onProcessEscape);
            editor.listeners.signals.onGlobalMouseMove.add(onMouseMove);
            editor.renderer.domElement.addEventListener('keydown', onKeyDown);
        }
        else {
            setTimeout(() => {
                if (props.extraContext && props.extraContext.getCurrentViewEditor()) {
                    const editor = props.extraContext.getCurrentViewEditor();
                    editor.listeners.signals.onDymodeVisible.add(onDymodeVisibleChange);
                    editor.listeners.signals.onProcessEscape.add(onProcessEscape);
                    editor.listeners.signals.onGlobalMouseMove.add(onMouseMove);
                    editor.renderer.domElement.addEventListener('keydown', onKeyDown);
                }
            }, 5000);
        }
        return (() => {
            if (props.extraContext && props.extraContext.getCurrentViewEditor()) {
                const editor = props.extraContext.getCurrentViewEditor();
                editor.listeners.signals.onProcessEscape.remove(onProcessEscape);
                editor.listeners.signals.onGlobalMouseMove.remove(onMouseMove);
                editor.listeners.signals.onDymodeVisible.remove(onDymodeVisibleChange);
                editor.renderer.domElement.removeEventListener('keydown', onKeyDown);
            }
        });
    }, [props.extraContext, props.context]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (focus === 'x') {
            (_a = refX === null || refX === void 0 ? void 0 : refX.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = refX === null || refX === void 0 ? void 0 : refX.current) === null || _b === void 0 ? void 0 : _b.select();
        }
        else if (focus === 'y') {
            (_c = refY === null || refY === void 0 ? void 0 : refY.current) === null || _c === void 0 ? void 0 : _c.focus();
            (_d = refY === null || refY === void 0 ? void 0 : refY.current) === null || _d === void 0 ? void 0 : _d.select();
        }
        else if (focus === 'z') {
            (_e = refZ === null || refZ === void 0 ? void 0 : refZ.current) === null || _e === void 0 ? void 0 : _e.focus();
            (_f = refZ === null || refZ === void 0 ? void 0 : refZ.current) === null || _f === void 0 ? void 0 : _f.select();
        }
    }, [focus]);
    useEffect(() => {
        if (command) {
            onDymodeConfirm(command);
        }
    }, [choose]);
    useEffect(() => {
        findCmdList();
    }, [cmdString]);
    const onDymodeVisibleChange = (visible, needFocus = false, strValue = "") => {
        if (!props.extraContext)
            return null;
        if (visible) {
            setInputVisible(true);
            if (props.extraContext.dymodeContext.enabled === false) {
                props.extraContext.dymodeContext.enabled = true;
            }
            if (!needFocus) {
                return;
            }
            let midMode = props.extraContext.dymodeContext.mode;
            let value = strValue.toUpperCase().trim();
            let option = props.extraContext.stmodeContext.options.find((item) => item.key === value);
            if (option) {
                midMode = DYMODE_MODE.CHOOSE;
                props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
            }
            setTimeout(() => {
                var _a, _b, _c, _d, _e, _f;
                if (midMode === DYMODE_MODE.POINT) {
                    (_a = refX === null || refX === void 0 ? void 0 : refX.current) === null || _a === void 0 ? void 0 : _a.focus({ cursor: 'all' });
                    setX(strValue);
                }
                else if (midMode === DYMODE_MODE.ANGLE) {
                    (_b = refAngle === null || refAngle === void 0 ? void 0 : refAngle.current) === null || _b === void 0 ? void 0 : _b.focus({ cursor: 'all' });
                    setAngle(strValue);
                }
                else if (midMode === DYMODE_MODE.DIST) {
                    (_c = refDist === null || refDist === void 0 ? void 0 : refDist.current) === null || _c === void 0 ? void 0 : _c.focus({ cursor: 'all' });
                    setDist(strValue);
                }
                else if (midMode === DYMODE_MODE.CHOOSE) {
                    (_d = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _d === void 0 ? void 0 : _d.focus({ cursor: 'all' });
                    setChoose(strValue);
                }
                else if (midMode === DYMODE_MODE.NUMBER) {
                    (_e = refNumber === null || refNumber === void 0 ? void 0 : refNumber.current) === null || _e === void 0 ? void 0 : _e.focus({ cursor: 'all' });
                    setNumber(strValue);
                }
                else if (midMode === DYMODE_MODE.COMMAND) {
                    (_f = refCommand === null || refCommand === void 0 ? void 0 : refCommand.current) === null || _f === void 0 ? void 0 : _f.focus({ cursor: 'all' });
                    setCmdString(strValue);
                }
            }, 0);
            setMask(true);
        }
        else {
            setInputVisible(false);
            reset();
        }
    };
    const activateDymodeInput = (visible) => {
        var _a, _b, _c, _d, _e, _f;
        if (!props.extraContext)
            return null;
        {
            if (props.extraContext.dymodeContext.enabled === false) {
                props.extraContext.dymodeContext.enabled = true;
            }
            setInputVisible(true);
            if (props.extraContext.dymodeContext.mode === DYMODE_MODE.POINT) {
                (_a = refX === null || refX === void 0 ? void 0 : refX.current) === null || _a === void 0 ? void 0 : _a.focus({ cursor: 'all' });
            }
            else if (props.extraContext.dymodeContext.mode === DYMODE_MODE.ANGLE) {
                (_b = refAngle === null || refAngle === void 0 ? void 0 : refAngle.current) === null || _b === void 0 ? void 0 : _b.focus({ cursor: 'all' });
            }
            else if (props.extraContext.dymodeContext.mode === DYMODE_MODE.DIST) {
                (_c = refDist === null || refDist === void 0 ? void 0 : refDist.current) === null || _c === void 0 ? void 0 : _c.focus({ cursor: 'all' });
            }
            else if (props.extraContext.dymodeContext.mode === DYMODE_MODE.CHOOSE) {
                (_d = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _d === void 0 ? void 0 : _d.focus({ cursor: 'all' });
            }
            else if (props.extraContext.dymodeContext.mode === DYMODE_MODE.NUMBER) {
                (_e = refNumber === null || refNumber === void 0 ? void 0 : refNumber.current) === null || _e === void 0 ? void 0 : _e.focus({ cursor: 'all' });
            }
            else if (props.extraContext.dymodeContext.mode === DYMODE_MODE.COMMAND) {
                (_f = refCommand === null || refCommand === void 0 ? void 0 : refCommand.current) === null || _f === void 0 ? void 0 : _f.focus({ cursor: 'all' });
            }
            setMask(true);
        }
    };
    const onKeyDown = (event) => {
        const dymodeContext = props.extraContext.dymodeContext;
        if (dymodeContext && !dymodeContext.enabled && props.extraContext.editStatusContext.dymode && dymodeContext.mode === DYMODE_MODE.COMMAND) {
            if ((65 <= event.keyCode && event.keyCode <= 90) || (48 <= event.keyCode && event.keyCode <= 57)) {
                dymodeContext.enabled = true;
                activateDymodeInput();
            }
        }
    };
    const onMouseMove = (left, top, needUpdate = false) => {
        if (!needUpdate) {
            setLeft(left + (props.leftOffset ? props.leftOffset : 0));
            setTop(top + (props.topOffset ? props.topOffset : 0));
            return;
        }
        setUpdatePage((prev) => prev + 1);
    };
    const onInputXChange = (e) => {
        var _a;
        let value = e.target.value;
        let chooseValue = value.toUpperCase().trim();
        let option = props.extraContext.stmodeContext.options.find((item) => item.key === chooseValue);
        if (option) {
            setChoose(chooseValue);
            props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
            (_a = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _a === void 0 ? void 0 : _a.focus({ cursor: 'all' });
        }
        else {
            const reg = /^-?\d*(\.\d*)?$/;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                setX(e.target.value);
            }
        }
    };
    const onInputYChange = (e) => {
        let value = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            setY(e.target.value);
        }
    };
    const onInputZChange = (e) => {
        let value = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            setZ(e.target.value);
        }
    };
    const onInputXKeydown = (event) => {
        event.stopPropagation();
        const keyCode = event.keyCode;
        const reg = /^-?\d*(\.\d*)?$/;
        if (keyCode === 9 || keyCode === 188) {
            if (!((!isNaN(+x) && reg.test(x)) || x === '' || x === '-')) {
                return null;
            }
            setFocus('y');
            return false;
        }
        else if (keyCode === 108 || keyCode === 13 || keyCode === 32) {
            let value = event.target.value.toUpperCase().trim();
            let option = props.extraContext.stmodeContext.options.find((item) => item.key === value);
            if (!!option) {
                props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
                setChoose(value);
            }
            else {
                if (!((!isNaN(value) && reg.test(value)) || value === '' || value === '-')) {
                    return null;
                }
                onDymodeConfirm(command);
            }
        }
        return null;
    };
    const onInputYKeydown = (event) => {
        event.stopPropagation();
        const keyCode = event.keyCode;
        if (keyCode === 9 || keyCode === 188) {
            setZVisible(true);
            setFocus('z');
        }
        else if (keyCode === 108 || keyCode === 13 || keyCode === 32) {
            onDymodeConfirm(command);
        }
    };
    const onInputZKeydown = (event) => {
        event.stopPropagation();
        const keyCode = event.keyCode;
        if (keyCode === 108 || keyCode === 13 || keyCode === 32 || keyCode === 9) {
            onDymodeConfirm(command);
        }
    };
    const onChooseChange = (e) => {
        let value = e.target.value;
        const chooseValue = value.toUpperCase().trim();
        setChoose(chooseValue);
    };
    const onInputKeydown = (e) => {
        e.stopPropagation();
        if (!props.extraContext)
            return null;
        const keyCode = e.keyCode;
        if (keyCode === 188) {
            props.extraContext.dymodeContext.mode = DYMODE_MODE.POINT;
            let value = e.target.value;
            value = value.substring(0, value.length - 1);
            const reg = /^-?\d*(\.\d*)?$/;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                setX(value);
            }
            setFocus('y');
            return false;
        }
        else if (keyCode === 108 || keyCode === 13 || keyCode === 32 || keyCode === 9) {
            let value = e.target.value.toUpperCase().trim();
            let option = props.extraContext.stmodeContext.options.find((item) => item.key === value);
            if (props.extraContext.dymodeContext.mode === DYMODE_MODE.CHOOSE) {
                if (option) {
                    onDymodeConfirm(command);
                }
            }
            else {
                if (option) {
                    props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
                    setChoose(value);
                }
                else {
                    if (value.toString().match(/^\s*$/) || isNaN(value)) {
                        return null;
                    }
                    onDymodeConfirm(command);
                }
            }
        }
        return null;
    };
    const onCommandKeyup = (e) => {
        e.stopPropagation();
        const keyCode = e.keyCode;
        if (keyCode === 108 || keyCode === 13 || keyCode === 32 || keyCode === 9) {
            const editor = props.extraContext.getCurrentViewEditor();
            if (editor) {
                editor.renderer.domElement.focus();
            }
            onDymodeConfirm(command);
        }
    };
    const onNumberChange = (e) => {
        var _a, _b, _c;
        let chooseValue = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toUpperCase().trim();
        let option = props.extraContext.stmodeContext.options.find((item) => item.key === chooseValue);
        if (option) {
            setChoose(chooseValue);
            props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
            (_c = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _c === void 0 ? void 0 : _c.focus({ cursor: 'all' });
        }
        else {
            const numberValue = e.target.value.trim();
            setNumber(numberValue);
        }
    };
    const onAngleChange = (e) => {
        var _a, _b, _c;
        let chooseValue = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toUpperCase().trim();
        let option = props.extraContext.stmodeContext.options.find((item) => item.key === chooseValue);
        if (option) {
            setChoose(chooseValue);
            props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
            (_c = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _c === void 0 ? void 0 : _c.focus({ cursor: 'all' });
        }
        else {
            const angleValue = e.target.value.trim();
            setAngle(angleValue);
        }
    };
    const onDistChange = (e) => {
        var _a, _b, _c;
        let chooseValue = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toUpperCase().trim();
        let option = props.extraContext.stmodeContext.options.find((item) => item.key === chooseValue);
        if (option) {
            setChoose(chooseValue);
            props.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
            (_c = refChoose === null || refChoose === void 0 ? void 0 : refChoose.current) === null || _c === void 0 ? void 0 : _c.focus({ cursor: 'all' });
        }
        else {
            const distValue = e.target.value.trim();
            setDist(distValue);
        }
    };
    const onCommandChange = (e) => {
        let cmd = e.target.value.replace(/[\u4e00-\u9fa5]/g, '').toUpperCase().trim();
        setCmdString(cmd);
    };
    const findCmdList = () => {
        var _a, _b;
        if (!props.extraContext)
            return null;
        let cmdList = props.extraContext.cmdContext.getCmdList();
        let display = cmdList.filter(item => item.name.indexOf(cmdString) === 0) || [];
        let recent = ((_a = display.find(item => item.name === cmdString)) === null || _a === void 0 ? void 0 : _a.name) || ((_b = display.find(item => item.name.indexOf(cmdString) >= 0)) === null || _b === void 0 ? void 0 : _b.name) || cmdString;
        setCommand(recent);
        setDisplayCmdList(display);
    };
    const onCancel = () => {
        if (!props.extraContext)
            return null;
        reset();
        if (props.extraContext.dymodeContext.mode === DYMODE_MODE.COMMAND) {
            setInputVisible(false);
            props.extraContext.dymodeContext.enabled = false;
        }
        const editor = props.extraContext.getCurrentViewEditor();
        if (editor) {
            editor.renderer.domElement.focus();
        }
    };
    const onProcessEscape = () => {
        if (!props.extraContext)
            return null;
        props.extraContext.dymodeContext.reset();
        reset();
        setInputVisible(false);
    };
    const reset = () => {
        setMask(false);
        setX(null);
        setY(null);
        setZ(null);
        setAngle(null);
        setDist(null);
        setFocus('x');
        setChoose(null);
        setNumber(null);
        setZVisible(false);
        setCommand(null);
        setCmdString(null);
    };
    const onDymodeConfirm = (cmd) => {
        if (!props.extraContext)
            return null;
        let mode = props.extraContext.dymodeContext.mode;
        let data = {
            mode: mode,
            x: x !== null ? +x : props.extraContext.dymodeContext.x,
            y: y !== null ? +y : props.extraContext.dymodeContext.y,
            z: z !== null ? +z : props.extraContext.dymodeContext.z,
            angle: angle !== null ? +angle : props.extraContext.dymodeContext.angle,
            dist: dist !== null ? +dist : props.extraContext.dymodeContext.dist,
            choose: choose !== null ? choose : props.extraContext.dymodeContext.choose,
            number: number !== null ? +number : props.extraContext.dymodeContext.number,
            command: cmd,
        };
        if (!props.context || !props.context.ucsContext.getAxisList()) {
            return;
        }
        let ucs = props.context.ucsContext.getAxisList();
        let vector = ucs.axisX.clone().multiplyScalar(data.x).add(ucs.axisY.clone().multiplyScalar(data.y)).add(ucs.axisZ.clone().multiplyScalar(data.z));
        let world = ucs.origin.clone().add(vector);
        data.x = world.x;
        data.y = world.y;
        data.z = world.z;
        switch (mode) {
            case DYMODE_MODE.CHOOSE:
                props.extraContext.stmodeContext.pushLog(choose);
                break;
            case DYMODE_MODE.COMMAND:
                props.extraContext.stmodeContext.pushLog(cmd);
                break;
            case DYMODE_MODE.POINT:
                props.extraContext.stmodeContext.pushLog(`@${x || ''},${y || ''},${z || ''}`);
                break;
            case DYMODE_MODE.DIST:
                props.extraContext.stmodeContext.pushLog(`@${dist || ''}`);
                break;
            case DYMODE_MODE.ANGLE:
                props.extraContext.stmodeContext.pushLog(`@${angle || ''}`);
                break;
            case DYMODE_MODE.NUMBER:
                props.extraContext.stmodeContext.pushLog(`@${number || ''}`);
                break;
        }
        reset();
        props.extraContext.listeners.signals.onDymodeChanged.dispatch(data);
        const editor = props.extraContext.getCurrentViewEditor();
        if (editor) {
            editor.renderer.domElement.focus();
        }
    };
    const onCmdItemClick = (cmd) => {
        setCommand(cmd.name);
        onDymodeConfirm(cmd.name);
    };
    return (React.createElement(ContextMenuModal, { visible: (inputVisible) && ((_b = (_a = props.extraContext) === null || _a === void 0 ? void 0 : _a.editStatusContext) === null || _b === void 0 ? void 0 : _b.dymode), left: left, top: top, mask: mask, onCancel: onCancel, onRightClick: () => {
            var _a, _b;
            if (((_b = (_a = props === null || props === void 0 ? void 0 : props.extraContext) === null || _a === void 0 ? void 0 : _a.dymodeContext) === null || _b === void 0 ? void 0 : _b.mode) == DYMODE_MODE.COMMAND) {
                onDymodeConfirm(command);
            }
        }, onEscape: () => { var _a; return (_a = props.extraContext) === null || _a === void 0 ? void 0 : _a.listeners.signals.onProcessEscape.dispatch(); } },
        React.createElement("div", { className: "dymode-input-container" },
            ((_c = props.extraContext) === null || _c === void 0 ? void 0 : _c.dymodeContext.mode) !== DYMODE_MODE.COMMAND && (React.createElement("div", { className: "dymode-tip" }, (_d = props.extraContext) === null || _d === void 0 ? void 0 : _d.dymodeContext.tip)),
            ((_e = props.extraContext) === null || _e === void 0 ? void 0 : _e.dymodeContext.mode) === DYMODE_MODE.POINT && (React.createElement(Fragment, null,
                React.createElement(Input, { size: "small", className: classnames({
                        'dymode-input': true,
                        'disabled': focus !== 'x'
                    }), autoComplete: "off", value: x == null ? (_f = props.extraContext) === null || _f === void 0 ? void 0 : _f.dymodeContext.x : x, ref: refX, onChange: (e) => onInputXChange(e), onKeyUp: onInputXKeydown, tabIndex: -1 }),
                React.createElement(Input, { size: "small", id: "inputY", className: classnames({
                        'dymode-input': true,
                        'disabled': focus !== 'y'
                    }), autoComplete: "off", value: y == null ? (_g = props.extraContext) === null || _g === void 0 ? void 0 : _g.dymodeContext.y : y, ref: refY, tabIndex: -1, onChange: (e) => onInputYChange(e), onKeyUp: onInputYKeydown }),
                React.createElement(Input, { size: "small", autoComplete: "off", className: classnames({
                        'dymode-input': true,
                        'disabled': focus !== 'z'
                    }), style: {
                        display: zVisible ? 'block' : 'none'
                    }, tabIndex: -1, value: z == null ? (_h = props.extraContext) === null || _h === void 0 ? void 0 : _h.dymodeContext.z : z, ref: refZ, onChange: (e) => onInputZChange(e), onKeyUp: onInputZKeydown }))),
            ((_j = props.extraContext) === null || _j === void 0 ? void 0 : _j.dymodeContext.mode) === DYMODE_MODE.NUMBER && (React.createElement(Input, { size: "small", value: number == null ? (_k = props.extraContext) === null || _k === void 0 ? void 0 : _k.dymodeContext.number : number, ref: refNumber, className: classnames({
                    'dymode-input': true,
                }), autoComplete: "off", onChange: onNumberChange, onKeyUp: onInputKeydown })),
            ((_l = props.extraContext) === null || _l === void 0 ? void 0 : _l.dymodeContext.mode) === DYMODE_MODE.CHOOSE && (React.createElement(Input, { size: "small", value: choose == null ? (_m = props.extraContext) === null || _m === void 0 ? void 0 : _m.dymodeContext.choose : choose, ref: refChoose, className: classnames({
                    'dymode-input': true,
                }), autoComplete: "off", onChange: onChooseChange, onKeyUp: onInputKeydown })),
            ((_o = props.extraContext) === null || _o === void 0 ? void 0 : _o.dymodeContext.mode) === DYMODE_MODE.ANGLE && (React.createElement(Input, { size: "small", ref: refAngle, value: angle == null ? (_p = props.extraContext) === null || _p === void 0 ? void 0 : _p.dymodeContext.angle : angle, className: classnames({
                    'dymode-input': true,
                }), autoComplete: "off", onChange: onAngleChange, onKeyUp: onInputKeydown })),
            ((_q = props.extraContext) === null || _q === void 0 ? void 0 : _q.dymodeContext.mode) === DYMODE_MODE.DIST && (React.createElement(Fragment, null,
                React.createElement(Input, { size: "small", ref: refDist, value: dist == null ? (_r = props.extraContext) === null || _r === void 0 ? void 0 : _r.dymodeContext.dist : dist, className: classnames({
                        'dymode-input': true,
                    }), autoComplete: "off", onChange: onDistChange, onKeyUp: onInputKeydown }),
                ((_s = props.extraContext) === null || _s === void 0 ? void 0 : _s.dymodeContext.showDistAngle) && (React.createElement("div", { className: "dymode-angle-tip" },
                    NumFixed(props.extraContext.dymodeContext.angle, 1),
                    "\u00B0")))),
            ((_t = props.extraContext) === null || _t === void 0 ? void 0 : _t.dymodeContext.mode) === DYMODE_MODE.COMMAND && (React.createElement("div", null,
                React.createElement(Input, { size: "small", ref: refCommand, value: cmdString, className: classnames({
                        'dymode-input': true,
                        'command-input': true,
                    }), autoComplete: "off", onChange: onCommandChange, onKeyUp: onCommandKeyup }),
                React.createElement("div", { className: classnames({
                        "command-list": true,
                        'visible': displayCmdList.length > 0,
                    }) }, displayCmdList.map((cmd, idx) => (React.createElement("div", { key: idx, className: classnames({
                        "cmd-item": true,
                        'active': command === cmd.name
                    }), onClick: () => onCmdItemClick(cmd) },
                    React.createElement("span", null, cmd.name),
                    cmd.alias && (React.createElement("span", { className: "cmd-alias" },
                        " (",
                        cmd.alias,
                        ") "))))))))),
        React.createElement("div", { style: { display: 'none' } }, updatePage)));
}export{DymodeInput,index as MyButton};